import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import Layout from "./Components/Layout";
import "../src/assets/css/style-responsive.css";
import { ToastContainer } from "react-toastify";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <>
    <Layout>
      <App />
    </Layout>
    <ToastContainer
      position="top-right"
      style={{
        position: "fixed",
        top: "1rem",
        right: "1rem",
        zIndex: 9999,
        margin: 0,
        padding: 0,
      }}
    />
  </>
);

reportWebVitals();
